import {Route, useLocation} from "react-router-dom";
import React from "react";
import {Routes} from "react-router";
import {Practitioners} from "./Practitioners";
import {TeamLogins} from "./TeamLogins";
import {AddOrUpdatePractitioner} from "./AddOrUpdatePractitioner";
import {UpdateTeamMember} from "./UpdateTeamMember";
import {InviteTeamMember} from "./InviteTeamMember";

export const useTeamTabs = () => {

  const location = useLocation();

  return [{
    label: 'Practitioners',
    link: '..',
    isSelected: location.pathname == '/home/team',
  }, {
    label: 'User Accounts',
    link: '../logins',
    isSelected: location.pathname == '/home/team/logins',
  }];
}

export const TeamRouter = () => {

  return <Routes>
    <Route path={'/add'} element={<AddOrUpdatePractitioner/>}/>
    <Route path={'/edit/:providerIdParam'} element={<AddOrUpdatePractitioner/>}/>
    <Route path={'/'} element={<Practitioners/>}/>

    <Route path={'/logins/invite'} element={<InviteTeamMember/>}/>
    <Route path={'/logins/edit/:loginIdParam'} element={<UpdateTeamMember/>}/>
    <Route path={'/logins'} element={<TeamLogins/>}/>
  </Routes>
}